import { render, staticRenderFns } from "./heroHomepageGalleryV1.vue?vue&type=template&id=914a67cc&"
import script from "./heroHomepageGalleryV1.vue?vue&type=script&lang=js&"
export * from "./heroHomepageGalleryV1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/__w/one-stop-shop/one-stop-shop/one-stop-shop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('914a67cc')) {
      api.createRecord('914a67cc', component.options)
    } else {
      api.reload('914a67cc', component.options)
    }
    module.hot.accept("./heroHomepageGalleryV1.vue?vue&type=template&id=914a67cc&", function () {
      api.rerender('914a67cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "web/wp-content/themes/global-theme/views/blocks/heroHomepage/heroHomepageGalleryV1.vue"
export default component.exports